jQuery(document).ready(function($){
  
  // add class .scrolled on scroll  
  $(function () {
    $(window).on('load scroll resize orientationchange', function () {
      var $nav = $(".navbar-fixed-top");
      $nav.toggleClass('scrolled', $(this).scrollTop() > 8);
    });
  });
  
  // Mobile nav menu display toggle on click
  $('.mobile-menu').on('click', function(){
    // Switch class of menu icon
    $(this).toggleClass('open');
    $('body').toggleClass('menu-open');
    // Switch class of mobile nav
    $('.mobile-nav').toggleClass('nav-open');
    // white header and dropshadow
    $('header').toggleClass('open');
    // topbar shadow/styling
    $('.top-bar').toggleClass('open');
  });
  
  // tabs (pricing page and taxjar vs ava on mobile) 
  $('.tab').on('click', function(){
    if ($(this).parents('#toggle-able').length > 0) {
      $(this).toggleClass('active');
      $('.tab').not(this).removeClass('active');
      var target = $(this).attr('data-target');
      $('.'+target).toggleClass('show');
      $('.content').not('.'+target).removeClass('show');
    } else {
      $(this).addClass('active');
      $('.tab').not(this).removeClass('active');
      var target = $(this).attr('data-target');
      $('.'+target).addClass('show');
      $('.content').not('.'+target).removeClass('show');
    } 
  });
  
  // Resource Page Videos
  $('.carousel-buttons button').on('click tap', function() {
    $('[id*="wistia_simple_video"]').each(function() {
      $(this).get(0).pause();
    });
  });
  
  // Percentage Counter
  
  // To check If it is in Viewport 
  var $window = $(window);
  function check_if_in_view() {    
    $('.countervalue').each(function(){
      if ($(this).hasClass('start')){
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        if (elementBottom > viewportTop && elementTop < viewportBottom) {
          $(this).removeClass('start');
          $('.countervalue').text();
          var myNumbers = $(this).text();
          if (myNumbers == Math.floor(myNumbers)) {
            $(this).animate({
              Counter: $(this).text()
            }, {
              duration: 2800,
              easing: 'swing',
              step: function(now) {
                $(this).text(Math.ceil(now));                                
              }
            });
          } else {
            $(this).animate({
              Counter: $(this).text()
            }, {
              duration: 2800,
              easing: 'swing',
              step: function(now) {                                
                $(this).text(now.toFixed(2)); 
              }
            });
          }

        }
      }
    });
    // Progress Bar
    $(".progress").addClass("ready");
  }
  
  // $window.on('scroll', check_if_in_view);
  $window.on('load', check_if_in_view);


});
